import { Subtask } from "../models/Subtask";
import { Event } from "../models/Event";
import api from "./api";
import { clean } from "../utils/utils";

const PATH = "/api/v1/subtasks";

export const SubtaskService = {
  async getSubtask(matterId: string, taskId: string): Promise<Subtask | null> {
    try {
      const res = await api.get(`${PATH}/${taskId}`, {
        params: { matterId },
      });
      return res.data.data;
    } catch (err: any) {
      if (err.response?.status === 404) return null;
      throw err;
    }
  },

  async getAllSubtasks(matterId: string): Promise<Subtask[]> {
    const res = await api.get(PATH, {
      params: { matterId },
    });
    return res.data.data ?? [];
  },

  async createSubtask(
    matterId: string,
    taskData: Omit<
      Subtask,
      "_id" | "createdAt" | "updatedAt" | "createdBy" | "updatedBy"
    >,
  ): Promise<Subtask["_id"]> {
    const res = await api.post(PATH, {
      ...clean(taskData),
      matter: matterId,
    });
    return res.data.data._id;
  },

  async updateSubtask(
    taskId: string,
    updatedData: Partial<Omit<Subtask, "_id" | "createdAt">>,
  ): Promise<void> {
    await api.put(`${PATH}/${taskId}`, updatedData);
  },

  async deleteSubtask(matterId: string, taskId: string): Promise<void> {
    await api.delete(`${PATH}/${taskId}`, {
      params: { matterId },
    });
  },

  async getSubtaskEvents(matterId: string, taskId: string): Promise<Event[]> {
    const res = await api.get(`${PATH}/${taskId}/events`, {
      params: { matterId },
    });
    return res.data.data ?? [];
  },

  async getSubtasks(matterId: string, taskId: string): Promise<Subtask[]> {
    const res = await api.get(`${PATH}/${taskId}/subtasks`, {
      params: { matterId },
    });
    return res.data.data ?? [];
  },
};
